
import service from "../services/modelsDetails.service"; // Asegúrate de que el servicio esté configurado correctamente

export const modelsDetails = {
    namespaced: true,
    state: {
        data: [],
        currentPage: 1,
        lastPage: 1,
        links:[],
        getData:[],
    },
    getters: {
        allData: (state) => state.data,
        pagination: (state) => ({
            currentPage: state.currentPage,
            lastPage: state.lastPage,
        }),
        links: (state) => state.links,
        getData: (state) => state.getData,
    },
    actions: {
        async fetchData({ commit },pageUrl = null) {
            try {
                const response = await service.getAll(pageUrl); 

                commit('SET_DATA', response.data.data); 
                commit('SET_PAGINATION', {
                    currentPage: response.data.current_page,
                    lastPage: response.data.last_page,
                    links: response.data.links, // Agrega los links de paginación aquí
                });
            } catch (error) {
                console.error("Error fetching proyects:", error);
            }
        },
        async save(context,data) {
            try {
                let response;
                if(data.id==0){
                    response = await service.createData(data);
                }else{
                    response = await service.updateData(data.id,data);
                } 
                return response; 
            } catch (error) {
                console.error("Error save projects:", error);
                return error.response; 
            }
        },
        async delete({ commit }, userId) {
            try {
                const response = await service.deleteData(userId);
                commit('REMOVE_DATA', userId); // Asegúrate de tener una mutación para eliminar el usuario de la lista
                return response; // Puedes retornar la respuesta si es necesario
            } catch (error) {
                throw error.response; ; // Propaga el error para que sea manejado en el componente
            }
        },
        async deleteModel({ commit }, userId) {
            try {
                const response = await service.deleteModel(userId);
                commit('REMOVE_DATA', userId); // Asegúrate de tener una mutación para eliminar el usuario de la lista
                return response; // Puedes retornar la respuesta si es necesario
            } catch (error) {
                throw error.response; ; // Propaga el error para que sea manejado en el componente
            }
        },
        async getData({ commit }, id) {
            try {
                const response = await service.getData(id);
                commit('SET_GET_DATA', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
    
    },
    mutations: {
        SET_DATA(state, data) {
            state.data = data;
        },
        SET_PAGINATION(state, pagination) {
            state.currentPage = pagination.currentPage;
            state.lastPage = pagination.lastPage;
            state.links = pagination.links;
        },
        ADD_DATA(state, data) {
            state.data.push(data); // Agrega el nuevo usuario al array de usuarios
        },
        SET_GET_DATA(state, data) {
            state.getData = data;
        }
    },
};